enum UploadPrefix {
  AIGenerationImage = 'agi',
  AIGenerationDocument = 'agd',
}

export default UploadPrefix
